import {SecondaryAddressee} from 'ApplicationEntry/models/SecondaryAddressee';
import * as S from '../models/SecondaryAddressee';
import {createAction} from 'Shared/utilities/actionCreator';
import {reverseEnum} from 'Shared/utilities/enumUtility';
import {ZipCode} from 'ApplicationEntry/models/ZipCode';

export enum SecondaryAddresseeActionType {
  CHANGE_NAME = 'secondaryAddressee/CHANGE_NAME',
  CHANGE_ADDRESS = 'secondaryAddressee/CHANGE_ADDRESS',
  CHANGE_ADDRESS_LINE2 = 'secondaryAddressee/CHANGE_ADDRESS_LINE2',
  CHANGE_CITY = 'secondaryAddressee/CHANGE_CITY',
  CHANGE_STATE = 'secondaryAddressee/CHANGE_STATE',
  CHANGE_ZIP = 'secondaryAddressee/CHANGE_ZIP',
}

export const isSecondaryAddresseeAction = (action: any): action is SecondaryAddresseeAction =>
  action.type in reverseEnum(SecondaryAddresseeActionType);

export const changeName = (name: string) => createAction(SecondaryAddresseeActionType.CHANGE_NAME, {name});
export const changeAddress = (address: string) => createAction(SecondaryAddresseeActionType.CHANGE_ADDRESS, {address});
export const changeAddressLine2 = (addressLine2: string) =>
  createAction(SecondaryAddresseeActionType.CHANGE_ADDRESS_LINE2, {addressLine2});
export const changeCity = (city: string) => createAction(SecondaryAddresseeActionType.CHANGE_CITY, {city});
export const changeState = (state: string) => createAction(SecondaryAddresseeActionType.CHANGE_STATE, {state});
export const changeZip = (zip: ZipCode) => createAction(SecondaryAddresseeActionType.CHANGE_ZIP, {zip});

export type SecondaryAddresseeAction =
  | ReturnType<typeof changeName>
  | ReturnType<typeof changeAddress>
  | ReturnType<typeof changeAddressLine2>
  | ReturnType<typeof changeCity>
  | ReturnType<typeof changeState>
  | ReturnType<typeof changeZip>;

type SecondaryAddresseeState = SecondaryAddressee;
const DEFAULT_STATE: SecondaryAddresseeState = S.EmptySecondaryAddressee;

export default (state: SecondaryAddresseeState = DEFAULT_STATE, action: SecondaryAddresseeAction) => {
  switch (action.type) {
    case SecondaryAddresseeActionType.CHANGE_NAME:
      return S.changeName(action.payload.name)(state);
    case SecondaryAddresseeActionType.CHANGE_ADDRESS:
      return S.changeAddress(action.payload.address)(state);
    case SecondaryAddresseeActionType.CHANGE_ADDRESS_LINE2:
      return S.changeAddressLine2(action.payload.addressLine2)(state);
    case SecondaryAddresseeActionType.CHANGE_CITY:
      return S.changeCity(action.payload.city)(state);
    case SecondaryAddresseeActionType.CHANGE_STATE:
      return S.changeState(action.payload.state)(state);
    case SecondaryAddresseeActionType.CHANGE_ZIP:
      return S.changeZip(action.payload.zip)(state);
    default:
      return state;
  }
};
